import React from 'react';

export interface StatBadgeProps {
    /** The numeric value shown in the pill. */
    count: number;
    /** Caption shown next to the pill. */
    label: string;
    className?: string;
}

const StatBadge: React.FC<StatBadgeProps> = ({ count, label, className = '' }) => (
    <div className={`flex items-center gap-[6px] ${className}`}>
        <span className="min-w-[16px] h-[16px] px-[4px] rounded-md flex items-center justify-center text-[12px] font-mono font-semibold bg-[var(--malachite-accent-background-glass)] text-[var(--malachite-accent-foreground)]">
            {count.toLocaleString()}
        </span>
        <span className="text-[13px] font-medium text-[var(--malachite-accent-foreground)]">
            {label}
        </span>
    </div>
);

export default StatBadge;
export { StatBadge };
